module.exports = __webpack_public_path__ + "static/media/vrsky.d356bdef.jpg";